import React from 'react'
import { Box, Typography, Divider } from '@mui/material'
import { ApiAutoComplete } from '../../../../../components/FormElements/ApiAutoComplete'
import FormInput from '../../../../../components/FormElements/FormInput'
import MultiSelectApiAutoComplete from '../../../../../components/FormElements/MultiSelectApiAutoComplete'
import { RenderTagsType } from '../../../../../components/FormElements/MultiSelectWithCheckBox'
import { Link } from 'react-router-dom'
import { blue, grey } from '../../../../../colors'
import ROUTES from '../../../../../consts/paths'
import GenericDateTimePicker from '../../../../../components/GenericDateTimePicker'
import AttributesMultiSelect from '../../../../../components/FormElements/AttributesMultiSelect'
import { ATTRIBUTE_TYPES } from '../../../../../consts'

interface InitialFormProps {
  isEditAction: boolean
  selectedRow?: any
  control: any
}

export const InitialForm: React.FC<InitialFormProps> = ({ isEditAction, selectedRow, control }) => {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <ApiAutoComplete
        apiEndpoint="/api/divisions/summary/?category_name=Course"
        readOnly={isEditAction}
        required
        label="Course ID"
        labelField="abbreviation"
        name="courseId"
        valueField="abbreviation"
        getOptionSubLabel={(option => option?.title)}
        selectedItem={selectedRow?.course} />

      <FormInput name="abbreviation" label="Section ID" control={control} required />

      {!isEditAction && (
        <Typography fontSize="14px" mt={1} color={grey[850]}>
          Best practice: Spell out the whole Course Section ID
        </Typography>
      )}

      <FormInput name="title" label="Title" control={control} required />
      <MultiSelectApiAutoComplete
        name='instructors'
        apiEndpoint='/api/users/summary/'
        sortField='name'
        getOptionLabel={(option: any) => option.name}
        getOptionValue={(option: any) => option.userId}
        getOptionSubLabel={(option: any) => option.email}
        apiExtraParams={{ isFaculty: true }}
        label='Instructor(s)'
        renderTagsType={RenderTagsType.Chips}
      />

      <Typography fontSize="14px" color={grey[850]}>
        If the instructor does not exist, create a user profile &nbsp;
        <Link to={ROUTES.FACULTY_AND_STAFF} target="_blank" style={{ color: blue[500] }}>
          here.
        </Link>
      </Typography>
      <GenericDateTimePicker name="startTimestamp" label="Start Date" required />
      <GenericDateTimePicker name="endTimestamp" label="End Date" required />

      <Divider sx={{ mt: 4 }} />

      <Typography mt={4} fontWeight={600} >Optional Fields</Typography>
      <AttributesMultiSelect name="attributes" defaultAttributes={selectedRow?.attributes} extraParams={{ attributeType: ATTRIBUTE_TYPES.COURSE_ATTRIBUTES }} />

    </Box>
  )
}
